import styled from 'styled-components';

const StyledPlaceholderDiv = styled.div`
    height: 52vh;
`;

export default StyledPlaceholderDiv;
